import { ActionModel } from "../ActionModel";
import i18n from "@/i18n";
import { PasswordRequirements } from "../../data/passwordRequirements";

/** Модель стандартной авторизации финиста */
export class BaseLoginModel extends ActionModel {
  /** Логин */
  public Login: string = "";

  /**Правила заполнения логина */
  public LoginRules: Array<any> = [
    (l: any) => !!l || i18n.t("auth.errors.loginEmpty"),
    (l: any) => (l && l.length <= 200) || i18n.t("auth.errors.loginMaxLength")
  ];

  /** Пароль */
  public Password: string = "";

  /**Правила заполнения пароля */
  public PasswordRules: Array<any> = [
    (p: any) => !!p || i18n.t("auth.errors.passwordEmpty"),
    (p: any) =>
      (p && p.length <= 200) || i18n.t("auth.errors.passwordMaxLength")
  ];

  /** Новый пароль */
  public NewPassword: string = "";

  /**Признак изменения пароля */
  public _isChangePassword: boolean = false;

  /**Признак 2хэтапной аутентификации */
  public get Is2f(): boolean {
    return this._isNeedConfirm
  }

  /**Признак необходимости смены пароля */
  public get IsChangePassword(): boolean {
    return this._isChangePassword;
  }

  /**Проверка нового пароля*/
  public get NewPasswordRule(): () => any {
    const isValidPassword = this.PasswordRequirements.SatisfactoryPassword
      ? new RegExp(this.PasswordRequirements.SatisfactoryPassword).test(
        this.NewPassword
      )
      : true;
    return () => isValidPassword || i18n.t("auth.errors.passwordBad");
  }

  /**Проверяем, не повторяет ли новый пароль старый*/
  public get NewPasswordAsOldRule(): () => any {
    return () =>
      this.Password != this.NewPassword ||
      i18n.t("auth.errors.newAndOldPasswordsEqual");
  }

  /**Проверка подтверждения пароля*/
  public get ConfirmPasswordRule(): () => any {
    return () =>
      this.ConfirmPassword == this.NewPassword ||
      i18n.t("auth.errors.passwordsNotEqual");
  }

  /**Обычный пароль */
  public get NormalPassword(): boolean {
    return (
      (this.PasswordRequirements.SatisfactoryPassword
        ? new RegExp(this.PasswordRequirements.SatisfactoryPassword).test(
          this.NewPassword
        )
        : true) && this.NewPassword != this.Password
    );
  }

  /**Сильный пароль */
  public get StrongPassword(): boolean {
    return (
      (this.PasswordRequirements.StrongPassword
        ? new RegExp(this.PasswordRequirements.StrongPassword).test(
          this.NewPassword
        )
        : false) && this.NewPassword != this.Password
    );
  }

  /**Подтверждение пароля */
  public ConfirmPassword: string = "";

  /**Требования к паролю */
  public PasswordRequirements: PasswordRequirements = new PasswordRequirements();
}
